import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION18: PdfComponent = {
  type: 'section',
  id: 's18',
  title: '18. Audits and Investigations',
  content: [
    {
      type: 'bulletList',
      id: 's18bullets',
      bulletType: 'number',
      content: [
        {
          copy: "The Subscriber shall allow Kanda and/or its agents to access, inspect and audit the Subscriber's records, accounts and other relevant information and premises (including allowing copying of documents):",
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: "during normal business hours on Business Days and subject to a minimum of 3 Business Days' notice; and",
              },
              {
                copy: 'not more often than once in any rolling 12-month period,',
              },
            ],
          },
          subcopy:
            "to the extent this is reasonably required for the purpose of verifying the Subscriber's compliance with its obligations under this Agreement. Where such access, inspection or audit is required by a regulatory body or other governmental organisation, the Subscriber shall allow such inspection or audit at any time and there shall be no limit to the number of such inspections or audits that can be undertaken.",
        },
        {
          copy: "Kanda shall pay the auditor's reasonable costs and otherwise bear its own costs in connection with the audit or inspection, unless the records show that the Subscriber is in Material Breach of this Agreement, in which case the Subscriber shall pay the costs of the auditor and Kanda's other reasonable costs in connection with the audit or inspection.",
        },
        {
          copy: "When conducting audits, Kanda shall comply with the Subscriber's reasonable directions in order to minimise disruption to the Subscriber's business.",
        },
        {
          copy: 'The obligations under this clause 18 are in addition to, and without prejudice to, the obligations of the Subscriber and the rights of Kanda under Schedule 2 (Data Protection).',
        },
      ],
      prefix: '18',
    },
  ],
};
